import { differenceInYears } from 'date-fns'
import { AttendeeAgeStatus } from 'domain/models/AttendeeFormSchema/MakeAttendeeFormSchemaContext'

interface IAttendeeAgeStatusService {
  getAttendeeAgeStatus(
    birthDate?: Date,
    raceDate?: Date | null
  ): AttendeeAgeStatus
}

const isMinor = (birthDate: Date, fromDate: Date): boolean =>
  differenceInYears(fromDate, birthDate) < 18

export class AttendeeAgeStatusService implements IAttendeeAgeStatusService {
  getAttendeeAgeStatus(
    birthDate?: Date,
    raceDate?: Date | null
  ): AttendeeAgeStatus {
    if (!birthDate) {
      return 'UNKNOWN'
    }
    return isMinor(birthDate, raceDate ?? new Date()) ? 'MINOR' : 'ADULT'
  }
}
